<div class="no-result-msg">{{ message }}</div>
